import AutoPostGenerator from './AutoPostGenerator';

export default AutoPostGenerator;
